<template>
  <div class="profile-edit">
    <form class="profile-edit__form" @submit.prevent="submit">
      <div class="profile-edit__fields">
        <div class="profile-edit__row row">
          <div class="col-sm-6">
            <AppControl
              label="Имя"
              class="profile-edit__control"
              :error="getError('name')"
            >
              <AppInput
                v-model="$v.form.name.$model"
                class="profile-edit__input"
                :invalid="isInvalid('name')"
                placeholder="Введите имя"
                theme="second"
              />
            </AppControl>
          </div>

          <div class="col-sm-6">
            <AppControl
              label="Фамилия"
              class="profile-edit__control"
              :error="getError('surname')"
            >
              <AppInput
                v-model="$v.form.surname.$model"
                class="profile-edit__input"
                :invalid="isInvalid('surname')"
                placeholder="Введите фамилию"
                theme="second"
              />
            </AppControl>
          </div>

          <div class="col-12">
            <AppControl
              label="E-mail"
              class="profile-edit__control"
              :error="getError('email')"
            >
              <AppInput
                v-model="$v.form.email.$model"
                class="profile-edit__input"
                :invalid="isInvalid('email')"
                placeholder="Введите E-mail"
                theme="second"
                type="email"
              />
            </AppControl>
          </div>

          <div class="col-12">
            <AppControl
              label="Телефон"
              class="profile-edit__control"
              :error="getError('phone')"
            >
              <AppInput
                v-model="$v.form.phone.$model"
                class="profile-edit__input"
                :invalid="isInvalid('phone')"
                placeholder="Введите номер телефона"
                theme="second"
              />
            </AppControl>
          </div>

          <!-- <div class="col-12">
            <AppControl
              label="Пароль"
              class="profile-edit__control"
              :error="getError('password')"
            >
              <AppInput
                v-model="$v.form.password.$model"
                class="profile-edit__input"
                :invalid="isInvalid('password')"
                placeholder="Придумайте пароль"
                theme="second"
                type="password"
              />
            </AppControl>
          </div> -->
        </div>
      </div>

      <AppBtn
        :loading="loading"
        type="submit"
        class="profile-edit__submit"
        color="fourth"
      >
        Сохранить
      </AppBtn>
    </form>
  </div>
</template>

<script>
import AppControl from "@/components/ui/control/AppControl.vue";
import { getValidationMessage } from "@utils/validation-messages";
import { required, email, numeric } from "vuelidate/lib/validators";
import { requestAlert, showAlert } from "@/core/common/";
import { asyncModal } from "@/components/ui/modal/";
import clone from "lodash/clone";

window.showAlert = showAlert;

const defaultForm = () => ({
  name: "",
  surname: "",
  email: "",
  phone: "",
  password: "",
  agreement: false
});

const UserProfileEdit = {
  name: "UserProfileEdit",
  components: {
    AppControl
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: clone(this.user) || defaultForm(),
      loading: false
    };
  },

  validations: {
    form: {
      name: { required },
      surname: { required },
      email: { required, email },
      phone: { required, numeric }
      // password: { required },
    }
  },

  async created() {},

  methods: {
    getError(field) {
      return getValidationMessage(this.$v.form[field]);
    },

    isInvalid(field) {
      return this.$v.form[field].$error;
    },

    async submit() {
      if (this.loading) return;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const success = true;
        this.$modals.close(this);
        showAlert("nice");
        if (success) {
          this.$v.$reset();
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};

export default UserProfileEdit;

export function openModal(user) {
  return asyncModal({
    name: "profile-edit-modal",
    component: UserProfileEdit,
    title: "Редактирование профиля",
    props: {
      user
    }
  });
}
</script>

<style lang="scss">
.profile-edit {
  width: 470px;
  max-width: 100%;
  margin: 0 auto;

  &__fields {
    width: 360px;
    max-width: 100%;
    margin: 0 auto;

    @include breakpoint("xs-only") {
      width: 100%;
    }
  }

  &__control {
    margin-bottom: 25px;
  }

  &__submit {
    width: 270px;
    height: 50px;
    text-transform: uppercase;
    margin: 0 auto;
    display: flex;
    font-size: 16px;
  }

  &__agreement {
    font-size: 15px;
    display: flex;
    margin: 20px 0 30px;

    &.is-invalid {
      color: colors(warning);
    }
  }
}
</style>
